import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Modal, Button} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';

class ClearButton extends Component {
  constructor(props) {
    super(props);
    this.state = {'isOpen': false};
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleConfirm = this.handleConfirm.bind(this);
  }

  handleOpen() {
    const {wasCreated, wasSearched, verifiedPart} = this.props;

    if (!wasCreated && wasSearched) {
      if (verifiedPart) {
        this.setState({'isOpen': true});
      } else {
        this.props.restoreDealerEmergingOrdersPage();
      }
      return;
    }

    this.props.restoreDealerEmergingOrdersPage();
  }

  handleClose() {
    this.props.clearReplacementSectionPartQuotes();
    this.props.restoreDealerEmergingOrdersPage();
    this.setState({'isOpen': false});
  }

  handleConfirm() {
    const {agency, dealer, partCode, quantity} = this.props;
    this.props.saveDealerLostSale({agency, dealer, partCode, quantity});
    this.handleClose();
  }

  render() {
    return (
      <Modal
        size='small'
        open={this.state.isOpen}
        onClose={this.handleClose}
        trigger={<Button circular color='blue' icon='cancel' onClick={this.handleOpen} />}
      >
        <Modal.Content>
          <p className='medium'>¿Desea registrar la consulta como <strong>venta perdida</strong>?</p>
        </Modal.Content>
        <Modal.Actions>
          <Button secondary content='CANCELAR' onClick={this.handleClose} />
          <Button primary content='ACEPTAR' onClick={this.handleConfirm} />
        </Modal.Actions>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  const partCode = state.dealerEmergingOrders.partCode;
  const parts = state.dealerEmergingOrders.parts;
  const verifiedPart = parts.some(({original}) => partCode === original.code);

  return {
    'dealer': state.session.dealerId,
    'agency': state.session.dealerAgency,
    'quantity': state.dealerEmergingOrders.quantity,
    'wasSearched': state.dealerEmergingOrders.wasSearched,
    'wasCreated': state.dealerEmergingOrders.wasCreated,
    partCode,
    parts,
    verifiedPart,
  };
};

const {
  clearReplacementSectionPartQuotes,
  restoreDealerEmergingOrdersPage,
  saveDealerLostSale,
} = Actions;

export default connect(mapStateToProps, {
  clearReplacementSectionPartQuotes,
  restoreDealerEmergingOrdersPage,
  saveDealerLostSale,
})(ClearButton);
